import React from "react";
import {
  Container,
  Box,
  Typography,
  List,
  ListItem,
  Link,
  Divider,
} from "@mui/material";
/* Icons */
import AccessibilityNewIcon from "@mui/icons-material/AccessibilityNew";
import CalendarMonthIcon from "@mui/icons-material/CalendarMonth";
import OndemandVideoIcon from "@mui/icons-material/OndemandVideo";
import SkipNextIcon from "@mui/icons-material/SkipNext";
import SportsGymnasticsIcon from "@mui/icons-material/SportsGymnastics";
import SettingsSuggestIcon from "@mui/icons-material/SettingsSuggest";
import HandshakeIcon from "@mui/icons-material/Handshake";
import HealthAndSafetyIcon from "@mui/icons-material/HealthAndSafety";
import FavoriteBorderIcon from "@mui/icons-material/FavoriteBorder";
import NotificationsActiveIcon from "@mui/icons-material/NotificationsActive";

import { useTranslation } from "react-i18next";
import ourProductImg1 from "../../assets/LandingPage/ourProduct1Img.jpg";
import ourProductImg2 from "../../assets/LandingPage/ourProductImg2.jpg";

import OurProductFeatures from "../UI/OurProductFeatures";

const ProductEndCustomerPage = () => {
  const { t } = useTranslation();

  const links = t("productEndCustomer.links", { returnObjects: true }) || [];
  const guides = t("productEndCustomer.guides", { returnObjects: true }) || [];
  const literature =
    t("productEndCustomer.literature", { returnObjects: true }) || [];

  return (
    <Container
      sx={{
        minHeight: "100vh", // full screen height
        display: "flex",
        justifyContent: "center", // horizontal center
        alignItems: "center", // vertical center
        px: 4,
      }}
    >
      <Box
        className="white-background"
        sx={{
          width: "100%",
          maxWidth: "100%",
          p: { xs: 2, sm: 4 },
          borderRadius: 2,
          textAlign: "left",
          overflowY: "auto",
        }}
      >
        <Typography variant="h3" color="primary" gutterBottom sx={{ py: 5 }}>
          {t("productEndCustomer.heading")}
        </Typography>
        <Typography
          variant="body1"
          paragraph
          sx={{ textAlign: "justify", my: 4 }}
        >
          {t("productEndCustomer.intro")}
        </Typography>

        <Box
          style={{
            display: "grid",
            gap: 15,
            gridTemplateColumns: "repeat(auto-fit, minmax(300px, 1fr))",
          }}
        >
          <OurProductFeatures
            text={t(`productEndCustomer.section${1}Text`)}
            title={t(`productEndCustomer.section${1}Title`)}
          >
            <AccessibilityNewIcon sx={{ fontSize: 45 }} />
          </OurProductFeatures>
          <OurProductFeatures
            text={t(`productEndCustomer.section${2}Text`)}
            title={t(`productEndCustomer.section${2}Title`)}
          >
            <CalendarMonthIcon sx={{ fontSize: 45 }} />
          </OurProductFeatures>
          <OurProductFeatures
            text={t(`productEndCustomer.section${3}Text`)}
            title={t(`productEndCustomer.section${3}Title`)}
          >
            <OndemandVideoIcon sx={{ fontSize: 45 }} />
          </OurProductFeatures>
          <OurProductFeatures
            text={t(`productEndCustomer.section${4}Text`)}
            title={t(`productEndCustomer.section${4}Title`)}
          >
            <SkipNextIcon sx={{ fontSize: 45 }} />
          </OurProductFeatures>
          <OurProductFeatures
            text={t(`productEndCustomer.section${5}Text`)}
            title={t(`productEndCustomer.section${5}Title`)}
          >
            <SportsGymnasticsIcon sx={{ fontSize: 45 }} />
          </OurProductFeatures>
          <OurProductFeatures
            text={t(`productEndCustomer.section${6}Text`)}
            title={t(`productEndCustomer.section${6}Title`)}
          >
            <SettingsSuggestIcon sx={{ fontSize: 45 }} />
          </OurProductFeatures>
        </Box>

        <Divider sx={{ my: 4 }} />

        <Box sx={{ py: 3 }}>
          <Typography
            variant="h5"
            color="primary"
            gutterBottom
            sx={{ py: "10px", fontSize: "30px", fontWeight: "bold" }}
          >
            {t("productEndCustomer.postureTitle")}
          </Typography>
          <Box
            sx={{
              display: "grid",
              gridTemplateColumns: { xs: "1fr", md: "1fr 1fr" }, // 1 column on mobile, 2 on desktop
              gap: 5,
              py: 2,
              alignItems: "center",
              justifyContent: "center",
            }}
          >
            <img
              src={ourProductImg1}
              style={{ width: "100%", objectFit: "contain", maxWidth: "500px" }}
              alt="Posture reminders"
            />
            <Box sx={{ display: "flex", flexDirection: "column", gap: 3 }}>
              <OurProductFeatures text={t("productEndCustomer.postureSupport")}>
                <HandshakeIcon sx={{ fontSize: 45 }} />
              </OurProductFeatures>
              <OurProductFeatures
                text={t("productEndCustomer.posturePrevention")}
              >
                <NotificationsActiveIcon sx={{ fontSize: 45 }} />
              </OurProductFeatures>
            </Box>
          </Box>
        </Box>

        <Divider sx={{ my: 4 }} />

        <Box sx={{ py: 2 }}>
          <Typography
            variant="h5"
            color="primary"
            gutterBottom
            sx={{ py: "20px", fontSize: "30px", fontWeight: "bold" }}
          >
            {t("productEndCustomer.exerciseTitle")}
          </Typography>
          <Box
            sx={{
              display: "grid",
              gridTemplateColumns: { xs: "1fr", md: "1fr 1fr" }, // 1 column on mobile, 2 on desktop
              gap: 5,
              py: 2,
              alignItems: "center",

              justifyContent: "center",
            }}
          >
            <Box sx={{ display: "flex", flexDirection: "column", gap: 3 }}>
              <OurProductFeatures
                text={t("productEndCustomer.exercisePreventive")}
              >
                <FavoriteBorderIcon sx={{ fontSize: 45 }} />
              </OurProductFeatures>
              <OurProductFeatures
                text={t("productEndCustomer.exerciseCurative")}
              >
                <HealthAndSafetyIcon sx={{ fontSize: 45 }} />
              </OurProductFeatures>
            </Box>
            <img
              src={ourProductImg2}
              style={{ width: "100%", objectFit: "contain", maxWidth: "500px" }}
              alt="Posture reminders"
            />
          </Box>
        </Box>

        <Divider sx={{ my: 4 }} />

        <Box>
          <Typography
            variant="h5"
            color="primary"
            gutterBottom
            sx={{ py: "20px", fontSize: "30px", fontWeight: "bold" }}
          >
            {t("productEndCustomer.resourcesTitle")}
          </Typography>
          <Typography variant="body1" paragraph>
            {t("productEndCustomer.resourcesIntro")}
          </Typography>
        </Box>

        {/* Verlinkungen */}
        {links.length > 0 && (
          <>
            <Typography
              variant="subtitle1"
              gutterBottom
              sx={{ fontWeight: "bold" }}
            >
              Verlinkungen:
            </Typography>
            <List dense>
              {links.map((item, idx) => (
                <ListItem key={idx} sx={{ pl: 0 }}>
                  {item.href ? (
                    <Link
                      href={item.href}
                      target="_blank"
                      rel="noopener noreferrer"
                      underline="hover"
                    >
                      {item.label}
                    </Link>
                  ) : (
                    <Typography variant="body2">{item.label}</Typography>
                  )}
                </ListItem>
              ))}
            </List>
          </>
        )}

        {/* Leitfäden */}
        {guides.length > 0 && (
          <>
            <Typography
              variant="subtitle1"
              gutterBottom
              sx={{ fontWeight: "bold" }}
            >
              Leitfäden:
            </Typography>
            <List dense>
              {guides.map((item, idx) => (
                <ListItem key={idx} sx={{ pl: 0 }}>
                  {item.href ? (
                    <Link
                      href={item.href}
                      target="_blank"
                      rel="noopener noreferrer"
                      underline="hover"
                    >
                      {item.label}
                    </Link>
                  ) : (
                    <Typography variant="body2">{item.label}</Typography>
                  )}
                </ListItem>
              ))}
            </List>
          </>
        )}

        {/* Literatur */}
        {literature.length > 0 && (
          <>
            <Typography
              variant="subtitle1"
              gutterBottom
              sx={{ fontWeight: "bold" }}
            >
              Literatur:
            </Typography>
            <List dense>
              {literature.map((item, idx) => (
                <ListItem key={idx} sx={{ pl: 0 }}>
                  {item.href ? (
                    <Link
                      href={item.href}
                      target="_blank"
                      rel="noopener noreferrer"
                      underline="hover"
                    >
                      {item.label}
                    </Link>
                  ) : (
                    <Typography variant="body2">{item.label}</Typography>
                  )}
                </ListItem>
              ))}
            </List>
          </>
        )}

        <Typography variant="body2" color="text.secondary" sx={{ mt: 2 }}>
          {t("productEndCustomer.disclaimer")}
        </Typography>
      </Box>
    </Container>
  );
};

export default ProductEndCustomerPage;
